import React from 'react'
import { Form, Row, Col, Button, Typography } from 'antd'
import { ModeContext } from '../../provider/ModeProvider'

const { Title } = Typography

const CollectionInitializeForm: React.FC = () => {
    const { setMode } = ModeContext()

    return (
        <>
            <Row>
                <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
                    <Form.Item>
                        <Title level={5}>Create Collection</Title>
                        Create Collection with status depending on who you input as Sender Name. Created Collection might be remain at Pending status due our Compliance
                        system. This status will enabled you to simulate both available Completed and Rejected status for Collection later.
                    </Form.Item>
                    <Form.Item>
                        <Button onClick={() => setMode('collection-create')}>Next</Button>
                    </Form.Item>
                </Col>
            </Row>

            <br />
            <Row>
                <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
                    <Form.Item>
                        <Title level={5}>Update Collection</Title>
                        Update Collections is a feature that allows users to modify the data within a Collection, providing users with greater control and consistency when
                        modifying their data. You can simulate both available Completed and Rejected status for Collection.
                    </Form.Item>
                    <Form.Item>
                        <Button onClick={() => setMode('collection-update')}>Next</Button>
                    </Form.Item>
                </Col>
            </Row>

            <br />
            <Row>
                <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
                    <Form.Item>
                        <Title level={5}>Update Collection Account</Title>
                        Update Collection account is a feature that allows users to modify the data within a Collection Account, providing users with greater control and
                        consistency when modifying their data. You can simulate both available Pending and Active status for Collection.
                    </Form.Item>
                    <Form.Item>
                        <Button onClick={() => setMode('collection-account-update')}>Next</Button>
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}

export default CollectionInitializeForm
